export default {
  "b2b.produkt-editace-form.field.nazevCs.label": "Název CS",
  "b2b.produkt-editace-form.field.nazevEn.label": "Název EN",
  "b2b.produkt-editace-form.field.popisCs.label": "Popis CS",
  "b2b.produkt-editace-form.field.popisEn.label": "Popis EN",
  "b2b.produkt-editace-form.field.zkratka.label": "Zkratka",
  "b2b.produkt-editace-form.field.uzivaNapajeni.label": "Užívá napájení",
  "b2b.produkt-editace-form.field.vylucny.label": "Výlučný",
  "b2b.produkt-editace-form.field.parkovani.label": "Parkování",
  "b2b.produkt-editace-form.field.bezCasu.label": "Bez času",
  "b2b.produkt-editace-form.field.platnostOd.label": "Platnost od",
  "b2b.produkt-editace-form.button.delete": "Smazat",
  "b2b.produkt-editace-form.button.submit": "Uložit",
  "b2b.produkt-editace-form.button.cancel": "Zrušit",
  "b2b.produkt-editace-widget.titleNew": "Nový produkt",
  "b2b.produkt-editace-form.save-dialog.title": "Uložení produktu",
  "b2b.produkt-editace-form.delete-dialog.title": "Odstranění produktu"
};
